import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";
import AttachmentParameters from "messaging/attachments/_api/queries/attachment-parameters";

export default class AttachmentQuery {
  public readonly attachmentParameters: AttachmentParameters;
  public readonly paginationParameters: PaginationParameters;

  public get searchParams(): URLSearchParams {
    return new URLSearchParams([...this.paginationParameters.searchParams, ...this.attachmentParameters.searchParams]);
  }

  constructor(attachmentParameters: AttachmentParameters, paginationParameters: PaginationParameters) {
    this.paginationParameters = paginationParameters;
    this.attachmentParameters = attachmentParameters;
  }

  public isEqualTo(other: AttachmentQuery): boolean {
    if (!other) return false;
    return (
      this.attachmentParameters.isEqualTo(other.attachmentParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters)
    );
  }
}
